// Opciones fijas de las herramientas de dibujo del visor de parque solar.

// Patrón de guiones (dash) por tipo de trazo, tal como lo espera Konva.
export const DASH_PATTERNS = {
  solid: [],
  dashed: [6, 3],
  dotted: [2, 2],
}

// Opciones de los selects de la barra de diseño (reutilizadas por dibujo y vector).
export const STROKE_WIDTHS = [0.3, 0.5, 1, 1.5, 2, 3]
export const DASH_TYPES = ['solid', 'dashed', 'dotted'] // la etiqueta sale por $t(tipo)
export const FONT_SIZES = [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 64]

// --- Panel de propiedades -----------------------------------------------------
// Presets de grosor de trazo: 3 botones (fino/medio/grueso).
// value = ancho real que entiende el motor; key = etiqueta i18n.
export const STROKE_WIDTH_PRESETS = [
  { key: 'thin', value: 0.5 },
  { key: 'medium', value: 1 },
  { key: 'bold', value: 2 },
]

// Presets de tamaño de fuente: S/M/L/XL mapeados a valores de FONT_SIZES.
export const FONT_SIZE_PRESETS = [
  { key: 'S', value: 12 },
  { key: 'M', value: 16 },
  { key: 'L', value: 24 },
  { key: 'XL', value: 32 },
]

// Alineados de texto que soporta Konva.Text.
export const TEXT_ALIGNS = ['left', 'center', 'right']

// Paleta de colores de trazo (negro + acentos vivos).
export const STROKE_COLORS = ['#1e1e1e', '#e03131', '#2f9e44', '#1971c2', '#f08c00']

// Paleta de rellenos (sin relleno + tonos suaves).
export const FILL_COLORS = ['transparent', '#ffc9c9', '#b2f2bb', '#a5d8ff', '#ffec99']

// Paleta ampliada del popup compacto de color (top-picks = las de arriba; estas son la
// rejilla del selector). Trazo = tonos vivos; relleno = pasteles + transparente.
export const STROKE_PALETTE = [
  '#1e1e1e', '#343a40', '#495057', '#ffffff',
  '#e03131', '#2f9e44', '#1971c2', '#1098ad',
  '#f08c00', '#e8590c', '#9c36b5', '#6741d9',
]
export const FILL_PALETTE = [
  'transparent', '#ffffff', '#e9ecef', '#1e1e1e',
  '#ffc9c9', '#b2f2bb', '#a5d8ff', '#ffec99',
  '#eebefa', '#d0bfff', '#ffd8a8', '#c3fae8',
]

// Bordes del trazo vector: 'sharp' (lineJoin miter) | 'round' (lineJoin round).
export const EDGES = ['sharp', 'round']

// Acciones de capa (z-index) sobre el elemento seleccionado. `dir` lo interpreta el
// motor (moveToBottom / moveDown / moveUp / moveToTop). Icono FontAwesome por acción.
export const Z_INDEX_ACTIONS = [
  { dir: 'to-back', key: 'send_to_back', icon: 'angles-down' },
  { dir: 'backward', key: 'send_backward', icon: 'angle-down' },
  { dir: 'forward', key: 'bring_forward', icon: 'angle-up' },
  { dir: 'to-front', key: 'bring_to_front', icon: 'angles-up' },
]
